module.exports = __webpack_public_path__ + "static/media/eupro.baac7428.png";